export const ADDRESS_SEARCH_CONTAINER_TESTID = 'address-search-container-testid';
export const ADDRESS_SEARCH_INPUT_TESTID = 'address-search-input-testid';
